import { useLayoutEffect, useState } from "react";

import { useWindowSize } from "@/lib/react-use/use-window-size";

import { SIDE_MENU_MOBILE_ID } from "../../_constants";

/**
 * モバイル用のサイドメニューが描画されているかどうかを判定する
 *
 *  ※ 初期化時には、DOMが存在しないので false が返る
 *
 * @returns 描画されてる場合はtrue, 描画されていない場合はfalse
 */
export const useIsSideMenuMobileRendered = () => {
	const { width } = useWindowSize();
	const [sideMenuMobileEl, setSideMenuMobileEl] = useState<HTMLElement | null>(null);

	useLayoutEffect(() => {
		// 1024px未満の場合はサイドメニューが描画される
		const el = width < 1024 ? document.getElementById(SIDE_MENU_MOBILE_ID) : null;

		if (el !== sideMenuMobileEl) {
			setSideMenuMobileEl(el);
		}
	}, [sideMenuMobileEl, width]);

	return sideMenuMobileEl !== null;
};
